<!--
 * @Author: hongqi
 * @LastEditors: hongqi
 * @Date: 2021-01-08 16:46:19
 * @LastEditTime: 2021-01-08 17:38:18
-->

<template>
    <div>
        <img src="../../../assets/newImg/index_bg.png" class="bg-img" alt="">
        <div style="height:.25rem"></div>
        <div class="team-compute">
            <div class="w50">
                <div class="count">{{detail.count_company_members}}<span>人</span> </div>
                <div class="text">子公司人数</div>
            </div>
            <div class="w50">
                <div class="count">{{detail.sum_company_money}}<span>元</span> </div>
                <div class="text">总营业额</div>
            </div>
            <!-- <div class="w50">
                <div class="count">{{detail.my_pay_amount}}<span>元</span> </div>
                <div class="text">当月我的业绩</div>
            </div>
            <div class="w50">
                <div class="count">{{detail.my_team_pay_amount}}<span>元</span> </div>
                <div class="text">当月团队业绩</div>
            </div> -->
            <div class="line1-h"></div>
            <!-- <div class="line-w"></div> -->
        </div>
        <div style="height:1.25rem"></div>
        <div class="seletor">
            <div class="seletor-item">
                <div class="date" @click="show = true">{{timeValue||'全部'}}</div>
                <div class="search" @click="onRefresh">查询</div>
            </div>
            <div style="height:.18rem"></div>
            <div class="seletor-item">
                <input type="text" placeholder="输入昵称" v-model="search">
                <div class="search" @click="onRefresh">查询</div>
            </div>
        </div>
        <div class="list">
            <div class="sort">
                <div class="sort-item">
                    <div>昵称</div>
                </div>
                <div class="sort-item">
                    <div>下级人数</div>
                </div>
                <div class="sort-item">
                    <div>团队业绩</div>
                </div>
                <div class="sort-item">
                    <div>个人业绩</div>
                </div>
            </div>
            <div style="overflow:scroll;height:6.12rem">

                <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" :immediate-check="false">
                    <div class="child" v-for="(item,index) in detail.my_company_performance_list" :key="index">
                        <div class="left">
                            <div>{{item.nickname}}</div>
                            <div>{{item.phone}}</div>
                        </div>
                        <div class="center">{{item.spread_count || 0}}人</div>
                        <div class="right">{{item.sum_team_money || 0}}元</div>
                        <div class="right">{{item.sum_person_money || 0}}元</div>
                    </div>
                </van-list>

            </div>

        </div>
        <div style="height:.25rem"></div>
        <van-popup v-model="show" position="bottom">
            <van-datetime-picker :value="timeValue" v-model="maxDate" type="year-month" title="选择年月日" @confirm="confirm" />
        </van-popup>
    </div>
</template>

<script>
import { Popup, DatetimePicker, PullRefresh, List } from "vant";
import { myCompanyPerformance } from "@api/user";
export default {
    data() {
        return {
            show: false,
            detail: {},
            loading: false,
            finished: false,
            timeValue: "",
            search: "",
            order_order: -1,
            price_order: -1,
            refreshing: false,
            maxDate: new Date(),
            page: 1,
            limit: 10,
        };
    },
    mounted() {
        this.onRefresh();
    },
    methods: {
        saleSort() {
            this.price_order = -1;
            if (this.order_order == -1) {
                this.order_order = 1;
            } else if (this.order_order == 1) {
                this.order_order = 0;
            } else {
                this.order_order = -1;
            }
            this.onRefresh();
        },
        priceSort() {
            this.order_order = -1;
            if (this.price_order == -1) {
                this.price_order = 1;
            } else if (this.price_order == 1) {
                this.price_order = 0;
            } else {
                this.price_order = -1;
            }
            this.onRefresh();
        },
        confirm(val) {
            let year = val.getFullYear();
            let month = val.getMonth() + 1;
            if (month >= 1 && month <= 9) {
                month = `0${month}`;
            }
            this.timeValue = `${year}-${month}`;
            this.maxDate = val;
            this.show = false;
        },
        onRefresh() {
            this.page = 1;
            this.onLoad("refresh");
        },
        onLoad(type) {
            let params = {
                page: this.page,
                limit: this.limit,
                time: this.timeValue,
                search: this.search,
            };
            myCompanyPerformance(params).then((res) => {
                if (res.status === 200) {
                    if (type == "refresh") {
                        this.finished = false;
                        this.detail = res.data;
                        this.loading = false;
                        this.refreshing = false;
                    } else {
                        this.detail.my_company_performance_list = this.detail.my_company_performance_list.concat(
                            res.data.my_company_performance_list
                        );
                    }
                    this.page++;
                    this.loading = false;
                    if (res.data.my_company_performance_list.length < this.limit) {
                        this.finished = true;
                    }
                }
            });
        },
    },
    components: {
        "van-datetime-picker": DatetimePicker,
        "van-popup": Popup,
        "van-list": List,
        "van-pull-refresh": PullRefresh,
    },
};
</script>

<style lang="scss" scoped>
.list {
    background: #ffffff;
    border-radius: 0.2rem;
    margin: 0.24rem 0.22rem 0;
    // padding: 0 .3rem;
    box-sizing: border-box;
    box-shadow: 0px 0.02rem 0.3rem 0px rgba(157, 157, 157, 0.2);
    .child {
        display: flex;
        justify-content: space-between;
        padding: 0.24rem 0.22rem;
        box-sizing: border-box;
        border-bottom: 1px solid #f2f2f2;
        font-size: 0.3rem;
        color: #333333;
        align-items: center;
        &:last-child {
            border-bottom: 0;
        }
        .left {
            flex: 1;
        }
        .center {
            flex: 1;
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            text-align: center;
        }
        .right {
            flex: 1;
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            text-align: center;
        }
    }
    .sort {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        height: 1rem;
        .sort-item {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            div {
                font-size: 0.26rem;
                color: #666666;
            }
            img {
                width: 0.2rem;
                height: 0.28rem;
                margin-left: 0.22rem;
            }
        }
    }
}
.bg-img {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3.16rem;
}
.seletor {
    box-shadow: 0px 0.02rem 0.3rem 0px rgba(157, 157, 157, 0.2);
    padding: 0.18rem 0;
    margin: 0 0.22rem;
    box-sizing: border-box;
    .seletor-item {
        width: 100%;
        // height: .96rem;
        align-items: center;
        background: #ffffff;
        border-radius: 0.2rem;
        display: flex;
        justify-content: space-between;
        padding: 0 0.26rem;
        box-sizing: border-box;
        .date {
            width: 4.44rem;
            height: 0.6rem;
            background: #f8f8f8;
            border-radius: 0.08rem;
            display: flex;
            justify-content: center;
            align-items: center;
        }
        .search {
            width: 1.86rem;
            height: 0.6rem;
            border: 0.02rem solid #d01112;
            border-radius: 0.08rem;
            font-size: 0.3rem;
            font-weight: 600;
            color: #d01112;
            display: flex;
            justify-content: center;
            align-items: center;
        }
        input {
            width: 4.44rem;
            height: 0.6rem;
            background: #f8f8f8;
            text-align: center;
            border-radius: 0.08rem;
        }
    }
}
.team-compute {
    margin: 0 0.2rem;
    height: 2.12rem;
    margin-bottom: 0.24rem;
    background: url("../../../assets/newImg/myTeam_index_img1.png") no-repeat;
    background-size: 100% 100%;
    position: relative;
    z-index: 10;
    display: flex;
    flex-wrap: wrap;
    .line1-h {
        height: 0.8rem;
        width: 0.02rem;
        position: absolute;
        transform: translate(-50%, -50%);
        left: 50%;
        top: 50%;
        background: rgba(208, 17, 18, 0.2);
    }
    .line-w {
        width: 2rem;
        height: 0.02rem;
        position: absolute;
        transform: translate(-50%, -50%);
        left: 50%;
        top: 50%;
        background: rgba(208, 17, 18, 0.2);
    }
    .w50 {
        width: 50%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .count {
            font-size: 0.4rem;
            font-weight: 600;
            color: #d01112;
            span {
                font-size: 0.24rem;
            }
        }
        .text {
            margin-top: 0.1rem;
            font-size: 0.26rem;
            color: #333333;
        }
    }
}
</style>